import React, { useState } from "react";
import "./Adddevice.scss";
import "react-phone-input-2/lib/bootstrap.css";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Adddevice() {
  const today = new Date().toISOString().split('T')[0];

  const [formData, setFormData] = useState({
    te_device_name: "",
    te_mac_id: "",
    // te_deviceid: "",
    te_licenseactivationdate: today,
    te_licenseexpirationdate: "",
  });

  const [errors, setErrors] = useState({
    te_device_name: "",
    te_mac_id: "",
    // te_deviceid: "",
    te_licenseactivationdate: "",
    te_licenseexpirationdate: "",
  });

  const validateDeviceName = (value) => {
    if (!value.trim()) return "Please enter a Device name";
    const nameRegex = /^[A-Za-z0-9\-_]+(?:\s[A-Za-z0-9\-_]+)*$/;
    return nameRegex.test(value) ? "" : "Please enter a valid Device name";
  };

  const validateMacId = (value) => {
    if (!value.trim()) return "Please enter a Mac ID";
    if (value.includes(' ')) return "Mac ID should not contain spaces";
    const macIdRegex = /^[A-Fa-f0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>/?]+$/;
    return macIdRegex.test(value) ? "" : "Please enter a valid Mac ID";
  };

  const validateDeviceId = (value) => {
    if (!value.trim()) return "Please enter a Device ID";
    const deviceIdRegex = /^[A-Za-z0-9]+$/;
    return deviceIdRegex.test(value) ? "" : "Please enter a valid Device ID";
  };

  const validateDate = (value, type) => {
    if (!value) {
      return type === 'activation' 
        ? "Please select an Activation date" 
        : "Please select a Deactivation date";
    }
    const selectedDate = new Date(value);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (type === 'activation' && selectedDate < today) {
      return "Activation date cannot be in the past";
    }
    if (type === 'deactivation') {
      const tomorrow = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);
      if (selectedDate < tomorrow) {
        return "Deactivation date must be at least tomorrow";
      }
    }
    return "";
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => {
      const newData = { ...prevData, [name]: value };

      if (name === 'te_licenseexpirationdate') {
        if (newData.te_licenseactivationdate && new Date(value) <= new Date(newData.te_licenseactivationdate)) {
          newData.te_licenseactivationdate = '';
        }
      } else if (name === 'te_licenseactivationdate') {
        if (newData.te_licenseexpirationdate && new Date(value) >= new Date(newData.te_licenseexpirationdate)) {
          newData.te_licenseexpirationdate = '';
        }
      }

      return newData;
    });

    let errorMessage = "";
    switch (name) {
      case "te_device_name":
        errorMessage = validateDeviceName(value);
        break;
      case "te_mac_id":
        errorMessage = validateMacId(value);
        break;
      // case "te_deviceid":
      //   errorMessage = validateDeviceId(value);
      //   break;
      case "te_licenseactivationdate":
        errorMessage = validateDate(value, 'activation');
        break;
      case "te_licenseexpirationdate":
        errorMessage = validateDate(value, 'deactivation');
        break;
      default:
        break;
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: errorMessage,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const newErrors = {
      te_device_name: validateDeviceName(formData.te_device_name),
      te_mac_id: validateMacId(formData.te_mac_id),
      // te_deviceid: validateDeviceId(formData.te_deviceid),
      te_licenseactivationdate: validateDate(formData.te_licenseactivationdate, 'activation'),
      te_licenseexpirationdate: validateDate(formData.te_licenseexpirationdate, 'deactivation'),
    };

    setErrors(newErrors);

    if (Object.values(newErrors).some(error => error !== "")) {
      return;
    }

    const postData = {
      ...formData,
      te_companyid: JSON.parse(sessionStorage.getItem("userdata")).te_companyid, 
      te_createdby: JSON.parse(sessionStorage.getItem("userdata")).te_username, 
    };

    try {
      const response = await axios.post("/devlicense/add", postData, {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("access_token"),
        },
      });
      console.log('Device added successfully:', response.data);
      if (response.data.status === 200) {
        if(response.data.message==="DEVICE LICENSE KEY ADDED SUCCESSFULLY"){
        toast.success("DEVICE LICENSE KEY ADDED SUCCESSFULLY", 
        {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          
        });
        setFormData({
          te_device_name: "",
          te_mac_id: "",
          // te_deviceid: "",
          te_licenseactivationdate: "",
          te_licenseexpirationdate: "",
        });
      }
      else {
        toast.warn(response.data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
         
        });
      }
      } else {
        toast.warn(response.data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
         
        });
      }
    } catch (error) {
      console.error('Error adding device:', error.response.data);
      toast.error(error.response.data.data, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  const formatDate = (date) => {
    return date.toISOString().split("T")[0];
  };

  // const today = formatDate(new Date());
  
  const tomorrow = formatDate(new Date(new Date().setDate(new Date().getDate() + 1)));

  const getDateBefore = (date) => {
    let prevDay = new Date(date);
    prevDay.setDate(prevDay.getDate() - 1);
    return formatDate(prevDay);
  };

  const getDateAfter = (date) => {
    let nextDay = new Date(date);
    nextDay.setDate(nextDay.getDate() + 1);
    return formatDate(nextDay);
  };

  return (
    <div className="create-user">
      <div className="container-fluid">
        <div className="container">
          <form onSubmit={handleSubmit} style={{paddingTop:"100px"}}>
            <div className="addedit-container" style={{
              display: "flex",
              flexDirection: "column",
              height: "auto",
            }}>
              <h2 className="heading-h1">Register New Device</h2>
              <br />
              <div style={{ display: "flex", gap: "40px", paddingBottom: "20px" }}>
                <div className="align" style={{ flex: 1 }}>
                  <label className="label-color">
                    <span style={{ color: "#C91616" }}>*</span> Device Name
                  </label>
                  <input
                    type="text"
                    id="te_device_name"
                    name="te_device_name"
                    placeholder="Enter Device Name"
                    value={formData.te_device_name}
                    onChange={handleInputChange}
                  />
                  {errors.te_device_name && <p style={{ color: 'red' }}>{errors.te_device_name}</p>}
                </div>
                <div className="align" style={{ flex: 1 }}>
                  <label className="label-color">
                    <span style={{ color: "#C91616" }}>*</span> Mac ID
                  </label>
                  <input
                    type="text"
                    id="te_mac_id"
                    name="te_mac_id"
                    placeholder="Enter Mac ID"
                    value={formData.te_mac_id}
                    onChange={handleInputChange}
                  />
                  {errors.te_mac_id && <p style={{ color: 'red' }}>{errors.te_mac_id}</p>}
                </div>
              </div>

              <br />

              {/* <div className="align" style={{ flex: 1 }}>
                <label className="label-color">
                  <span style={{ color: "#C91616" }}>*</span> Device ID
                </label>
                <input
                  type="text"
                  id="te_deviceid"
                  name="te_deviceid"
                  placeholder="Enter Device ID"
                  value={formData.te_deviceid}
                  onChange={handleInputChange}
                />
                {errors.te_deviceid && <p style={{ color: 'red' }}>{errors.te_deviceid}</p>}
              </div> */}

              <br /><br />

              <div style={{ display: "flex", gap: "40px", paddingBottom: "36px" }}>
                <div className="align" style={{ flex: 1 }}>
                  <label className="label-color">
                    <span style={{ color: "#C91616" }}>*</span> Activation Date
                  </label>
                  <input
                    type="date"
                    id="te_licenseactivationdate"
                    name="te_licenseactivationdate"
                    className="date-input"
                    value={today} 
                    // value={formData.te_licenseactivationdate}
                    onChange={handleInputChange}
                    // min={today}
                    // max={formData.te_licenseexpirationdate ? getDateBefore(formData.te_licenseexpirationdate) : undefined}
                    onKeyDown={(e) => {
                      if (e.key !== 'Tab') {
                        e.preventDefault();
                      }
                    }}
                    readOnly
                  />
                  {errors.te_licenseactivationdate && <p style={{ color: 'red' }}>{errors.te_licenseactivationdate}</p>}
                </div>
                <div className="align" style={{ flex: 1 }}>
                  <label className="label-color">
                    <span style={{ color: "#C91616" }}>*</span> Deactivation Date
                  </label>
                  <input
                    type="date"
                    id="te_licenseexpirationdate"
                    name="te_licenseexpirationdate"
                    className="date-input"
                    value={formData.te_licenseexpirationdate}
                    onChange={handleInputChange}
                    min={formData.te_licenseactivationdate ? getDateAfter(formData.te_licenseactivationdate) : tomorrow}
                    onKeyDown={(e) => {
                      if (e.key !== 'Tab') {
                        e.preventDefault();
                      }
                    }}
                  />
                  {errors.te_licenseexpirationdate && <p style={{ color: 'red' }}>{errors.te_licenseexpirationdate}</p>}
                </div>
              </div>
              <div className="button-component">
                <button
                  style={{ marginBottom: "30px" }}
                  type="submit"
                  className="create-button"
                >
                  Register
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Adddevice;